import { decodeBase64ToUnicode } from '@shared/utils/string';
import { useQuery } from '@tanstack/react-query';
import { getCacheTime } from '../query/time';
import { fetchAgreementsById, fetchSignedAgreements } from './api';
import { AgreementDocument } from './types';

export const useAgreementsByIdQuery = (agreementIds: string[]) => {
  const { data: agreements = [], ...rest } = useQuery({
    queryKey: ['agreements', agreementIds],
    queryFn: () => fetchAgreementsById(agreementIds).then(transform),
    ...getCacheTime('long'),
    enabled: agreementIds.length > 0,
  });

  return { agreements, ...rest };
};

export const useSignedAgreementsQuery = () => {
  return useQuery({
    queryKey: ['signedAgreements'],
    queryFn: () => fetchSignedAgreements(),
    ...getCacheTime('long'),
  });
};

const transform = (agreements?: AgreementDocument[]) =>
  agreements?.map((agreement) => ({
    ...agreement,
    content: decodeBase64ToUnicode(agreement.content),
  }));
